// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Diferenciais_secao__ST1aZ {
  padding: 6rem 1.5rem;
  max-width: 1100px;
  margin: 0 auto;
}

.Diferenciais_etiqueta__lFPJz {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.8rem;
  color: hsl(217, 91%, 60%);
  margin-bottom: 1rem;
  display: block;
  text-align: center;
}

.Diferenciais_titulo__omHM- {
  font-size: 2.5rem;
  font-weight: 800;
  color: hsl(210, 40%, 95%);
  margin-bottom: 3rem;
  text-align: center;
}

.Diferenciais_grade__SkcVU {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.25rem;
}

.Diferenciais_card__9E6z1 {
  background: hsl(222, 44%, 9%);
  border: 1px solid hsl(222, 30%, 18%);
  border-radius: 0.75rem;
  padding: 1.75rem;
  transition: all 0.3s ease;
}

.Diferenciais_card__9E6z1:hover {
  border-color: hsl(217, 91%, 60%, 0.25);
  transform: translateY(-3px);
  box-shadow: 0 8px 30px hsl(217, 91%, 60%, 0.06);
}

.Diferenciais_icone__OsYOf {
  font-size: 1.75rem;
  margin-bottom: 1rem;
}

.Diferenciais_cardTitulo__NCFfN {
  font-size: 1.1rem;
  font-weight: 700;
  color: hsl(210, 40%, 92%);
  margin-bottom: 0.5rem;
}

.Diferenciais_cardDescricao__6TAth {
  color: hsl(215, 20%, 55%);
  font-size: 0.9rem;
  line-height: 1.65;
}
`, "",{"version":3,"sources":["webpack://./src/components/Diferenciais/Diferenciais.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".secao {\n  padding: 6rem 1.5rem;\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.etiqueta {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 0.8rem;\n  color: hsl(217, 91%, 60%);\n  margin-bottom: 1rem;\n  display: block;\n  text-align: center;\n}\n\n.titulo {\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: hsl(210, 40%, 95%);\n  margin-bottom: 3rem;\n  text-align: center;\n}\n\n.grade {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.25rem;\n}\n\n.card {\n  background: hsl(222, 44%, 9%);\n  border: 1px solid hsl(222, 30%, 18%);\n  border-radius: 0.75rem;\n  padding: 1.75rem;\n  transition: all 0.3s ease;\n}\n\n.card:hover {\n  border-color: hsl(217, 91%, 60%, 0.25);\n  transform: translateY(-3px);\n  box-shadow: 0 8px 30px hsl(217, 91%, 60%, 0.06);\n}\n\n.icone {\n  font-size: 1.75rem;\n  margin-bottom: 1rem;\n}\n\n.cardTitulo {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: hsl(210, 40%, 92%);\n  margin-bottom: 0.5rem;\n}\n\n.cardDescricao {\n  color: hsl(215, 20%, 55%);\n  font-size: 0.9rem;\n  line-height: 1.65;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"secao": `Diferenciais_secao__ST1aZ`,
	"etiqueta": `Diferenciais_etiqueta__lFPJz`,
	"titulo": `Diferenciais_titulo__omHM-`,
	"grade": `Diferenciais_grade__SkcVU`,
	"card": `Diferenciais_card__9E6z1`,
	"icone": `Diferenciais_icone__OsYOf`,
	"cardTitulo": `Diferenciais_cardTitulo__NCFfN`,
	"cardDescricao": `Diferenciais_cardDescricao__6TAth`
};
export default ___CSS_LOADER_EXPORT___;
